import { Component, Input } from "@angular/core";
import { SystemReportsComponent } from "../../systemreports/system.reports.component";

@Component({
    selector: "app-sms-reports",
    templateUrl: "./reports.component.html",
    styleUrls: ["./reports.component.scss"],
    standalone: true,
    imports: [SystemReportsComponent]
})
export class ReportsComponent {
  @Input() map;
}
